module.exports = __webpack_public_path__ + "static/media/OSD.7f8b289d.pdf";